import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { UserIdleModule } from 'angular-user-idle';
import { AppComponent } from './app.component';
// Import containers
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
const APP_CONTAINERS = [
  DefaultLayoutComponent,
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule, routes } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ToastrModule } from 'ngx-toastr';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { NgxPaginationModule } from 'ngx-pagination';
import { TokenInterceptorService } from './TokenInterceptor.service';
import { RouterModule } from '@angular/router';
// Mat
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormGuardService } from './guard/form-guard.service';
import { MessageComponent } from './message/message.component';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';
import { LandingPageComponent } from './auth/landing-page/landing-page.component';
// import { HttpModule } from '@angular/http';
import { LogoutComponent } from './auth/logout/logout.component';
import { Page404Component } from './auth/page404/page404.component';
import { Page401Component } from './auth/page401/page401.component';
import { Page403Component } from './auth/page403/page403.component';
import { AuthGuard } from './guard/auth.guard';
import { LoadingPageComponent } from './auth/loading-page/loading-page.component';
import { SamlRequestComponent } from './auth/saml-request/saml-request.component';
// import { RegularExpressionComponent } from './service/regular-expression/regular-expression.component';
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppHeaderModule,
    AppBreadcrumbModule.forRoot(),
    AppAsideModule,
    AppFooterModule,
    AppSidebarModule,
    MatSliderModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    NgxMaterialTimepickerModule,
    NgxPaginationModule,
    // Mat
    MatDialogModule,
    MatButtonModule,
    ChartsModule,
    RouterModule.forRoot(routes, { useHash: false }),
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    // HttpModule ,
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      tapToDismiss: true
    }),
    FontAwesomeModule,
    ModalModule.forRoot(),
    NgxSpinnerModule,
    UserIdleModule.forRoot({ idle: 10, timeout: 10, ping: 120 }),
  ], schemas: [CUSTOM_ELEMENTS_SCHEMA],

  declarations: [
    AppComponent,
    APP_CONTAINERS,
    LoginComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    MessageComponent,
    LandingPageComponent,
    LogoutComponent,
    Page404Component,
    Page401Component,
    Page403Component,
    LoadingPageComponent,
    SamlRequestComponent,
    // RegularExpressionComponent
  ],
  providers: [FormGuardService,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
  ],


  bootstrap: [AppComponent],
  entryComponents: [MessageComponent],
})
export class AppModule { }
